import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.6662 8.33298H15.636C15.9201 8.33299 16.1994 8.40559 16.4475 8.54391C16.6956 8.68222 16.9042 8.88164 17.0536 9.12325C17.2029 9.36486 17.2881 9.64063 17.3009 9.92438C17.3137 10.2081 17.2538 10.4905 17.1268 10.7445L14.2102 16.5776C14.0718 16.8547 13.8589 17.0877 13.5954 17.2505C13.332 17.4133 13.0283 17.4994 12.7186 17.4993H9.37127C9.23544 17.4993 9.09961 17.4826 8.96712 17.4493L5.83308 16.666M11.6662 8.33298V4.16648C11.6662 3.72447 11.4906 3.30056 11.178 2.98801C10.8655 2.67547 10.4416 2.49988 9.99958 2.49988H9.92041C9.50376 2.49988 9.16628 2.83736 9.16628 3.25401C9.16628 3.84899 8.99045 4.43063 8.65963 4.92561L5.83308 9.16628V16.666M11.6662 8.33298H9.99958M5.83308 16.666H4.16648C3.72447 16.666 3.30056 16.4904 2.98801 16.1778C2.67547 15.8653 2.49988 15.4414 2.49988 14.9994V9.99958C2.49988 9.55757 2.67547 9.13366 2.98801 8.82111C3.30056 8.50857 3.72447 8.33298 4.16648 8.33298H6.24973",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }